/** Read numeric user id from the JWT in localStorage. */
export function getCurrentUserIdFromToken(): number | null {
  try {
    const token = localStorage.getItem('token');
    if (!token) return null;
    const encoded = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(encoded)) as Record<string, unknown>;
    const value = payload.userId ?? payload.sub ?? payload.id;
    const userId = Number(value);
    return Number.isFinite(userId) ? userId : null;
  } catch {
    return null;
  }
}
